module.exports = __webpack_public_path__ + "static/media/_baked_ranger-upd.af65ef92.glb";